import React from 'react';
import styles from './noPolicyLink.module.scss';
import { Medium12, SemiBold18 } from '@/components/design-system';
import { useDashboard } from '@/contexts/dashboard/dashboard.context';

const NoPolicyLink = () => {
  const { dashboardLabels } = useDashboard();
  const {
    policyDetailsCms: { noPolicy },
  } = dashboardLabels;

  return (
    <div
      className={styles['main-con']}
      style={
        {
          '--bg-image': `url(/images/dashboard/noPolicyBg.png)`,
        } as React.CSSProperties
      }
    >
      <div className={styles['top-con']}>
        <div className={styles['text-con']}>
          <SemiBold18>{noPolicy.title}</SemiBold18>
          <Medium12 color="var(--midnight-500)">{noPolicy.subtitle}</Medium12>
        </div>
        {
          // TEMP: removed for interim
          //
          //   <PrimarySmallButton
          //     color="var(--primary-midnight)"
          //     clevertapEventName={noPolicy.buttonTextClevertapEvent?.name}
          //     clevertapEventPayload={noPolicy.buttonTextClevertapEvent?.payload}
          //     onClick={() => {
          //       router.push(ROUTER_GROUPS.policy.actions.manualLinking());
          //     }}
          //   >
          //     <div className={styles['button-con']}>
          //       <IconPlus size={16} />
          //       <Medium12>{noPolicy.buttonText}</Medium12>
          //     </div>
          //   </PrimarySmallButton>
          // </div>
          // <div className={styles['bottom-con']}>
          //   <Medium14 color="var(--midnight-600)">{noPolicy.desc}</Medium14>
        }
      </div>
    </div>
  );
};

export default NoPolicyLink;
